import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { OverlayModule } from "@angular/cdk/overlay";

import { AppMaterialModule } from "./material.module";
import { DirectivesModule } from "./directive.module";
import { PipesModule } from "./pipe.module";
import { ChartsModule } from "ng2-charts";
import { NgbModule, NgbPopoverModule, NgbTooltipModule, NgbDatepickerModule, NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { NgImageFullscreenViewModule } from "ng-image-fullscreen-view";
import { NgSelectModule } from "@ng-select/ng-select";
import { SwiperModule } from "swiper/angular";

export const miscellaneousModules = [
  CommonModule,
  FlexLayoutModule,
  FormsModule,
  ReactiveFormsModule,
  OverlayModule,
  PipesModule,
  DirectivesModule,
  AppMaterialModule,

  ChartsModule,
  SwiperModule,
  NgbModule,
  NgbDatepickerModule,
  NgbPopoverModule,
  NgbTooltipModule,
  NgbTimepickerModule,
  NgImageFullscreenViewModule,
  NgSelectModule
];

@NgModule({
  imports: [...miscellaneousModules],
  exports: [...miscellaneousModules]
})
export class MiscellaneousModule { }
